import { useState } from "react";
import Button from "./Button";
import { Event } from "../graphql";

interface MeetingCardProps {
    event: Partial<Event>
}

const MeetingCard: React.FC<MeetingCardProps> = ({ event }) => {

    const [approving, setApproving] = useState(false)
    const isApproved = false;

    const time = new Date(event.start_at!)
    const month = time.toDateString()
    const title = "Personal Meeting"

    return (
        <div className={`space-y-5 border py-4 px-6 rounded-xl border-light-secondary/10 shadow m-1 ${isApproved && 'bg-lime-50/10 '}`}>
            <div className="flex flex-row gap-3 md:items-center">
                <div className="bg-dark text-white flex  flex-col w-12 h-12 font-Inter rounded-xl text-center justify-center">
                    <div className="flex flex-col -space-y-1.5 -ms-0.5 -mt-0.5">
                        <span className="text-md">{month.split(" ")[2]}</span>
                        <span className="text-[10px]">{month.split(" ")[1]}</span>
                    </div>
                </div>
                <div className="font-Poppins">
                    <span className="text-md font-semibold flex text-dark">
                        {title}
                    </span>
                    <span className="text-light-secondary font-medium text-xs">
                        {time.toLocaleTimeString("en-GB").substring(0, 5)}
                    </span>
                </div>
            </div>
            <div className="flex justify-between flex-row items-center">
                <div className="text-light-secondary font-Poppins text-xs font-medium">
                    {event.trainerId}
                </div>
                <div>
                    {isApproved ? <div className="text-green-700">Approved</div> :
                        <Button sm fontLight loading={approving} onClick={async () => {
                            setApproving(true);
                            setTimeout(() => {
                                setApproving(false)
                            }, 2000);
                            // await approve();
                        }}>Check Out</Button>}
                </div>
            </div>


        </div>
    );
}

export default MeetingCard;